import type { StockIndicatorProps } from '@thisisdmg/tirecloud-patterns';
import type { AppConfig } from '@/features/app/types/app-config';

const importMetaEnv = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
const env = importMetaEnv ?? process.env;

const appConfig = {
  appName: 'TireCloud Demo',
  apiUrl: env.REACT_APP_API_URL ?? '',
  defaultDocumentTitle: 'TireCloud Demo',
  authTokenKey: 'auth_token',
  settingLanguageKey: 'setting_language',
  accessTokenExpireDateKey: 'access_token_expires_at',
  refreshTokenExpireDateKey: 'refresh_token_expires_at',
  accessTokenKey: 'access_token',
  refreshTokenKey: 'refresh_token',
  rememberMeKey: 'remember_me',
  tokenCheckInterval: 30 * 60 * 1000, // 30 minutes
  tokenCheckThreshold: 5 * 24 * 60 * 60 * 1000, // 5 days
  refreshTokenThreshold: 1 * 24 * 60 * 60 * 1000, // 1 days
  appUpdateModalRemindMeLaterKey: 'app_update_modal_remind_me_later',
  defaultAdminPage: '/admin/analytics',
  cookieConsentKey: 'cookie_consent',
  onboardingKeyPrefix: 'onboarding_',
  adminDashboardSettingKey: 'admin_dashboard_setting',
  stockLowThreshold: 20,
  cartPromoCodeKey: 'cart_promo_code',
  fakeMaxStock: 1000,
  showStockCountOnStatus: ['low'] as StockIndicatorProps['showStockOn'],
  productDataStaleTime: 1000 * 60 * 5,
  defaultDataStaleTime: 1000 * 60 * 5,
  defaultLongDataStaleTime: 1000 * 60 * 10,
  minimumReservedStockQuantity: 1,
  serverTimezone: 'UTC',
} satisfies AppConfig;

export default appConfig;
